"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const heroSlides = [{
  intro: "KAYSERİ DİŞ HEKİMİ",
  title: "Diş Sıkma Botoksu",
  description: "Diş sıkma botoksu, masseter kaslarına yapılan enjeksiyonlarla kasın aşırı kasılmasını engelleyerek diş gıcırdatmayı durdurur. İşlem; muayene, kas analizi ve hızlı enjeksiyon aşamalarından oluşur.",
  ctaText: "Randevu Al",
  ctaLink: "/ContactPage",
  image: "https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/botoks.jpg?v=lwwzc6ia3ns"
}, {
  intro: "ESTETİK VE KONFOR",
  title: "Ağrısız Gülüşler",
  description: "Tedavi adımları; çene kaslarının incelenmesi, uygulama noktalarının sterilizasyonu ve ince uçlu iğnelerle konforlu botoks enjeksiyonu süreçlerini kapsar.",
  ctaText: "İletişime Geç",
  ctaLink: "/ContactPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/teeth_clenching_botox_step2.png"
}];
export default function HeroImage() {
  return <section data-section-id="178687" id="tedavi-tanıtımı" className="relative w-full bg-background animate-in fade-in duration-1000">
      <Carousel opts={{
      loop: true
    }} className="w-full">
        <CarouselContent>
          {heroSlides.map((slide, i) => <CarouselItem key={i} data-index={i} className="relative w-full h-[80vh] min-h-[600px] overflow-hidden">
              <img src={slide.image} alt={slide.title} className="absolute inset-0 w-full h-full object-cover" />
              <div className="absolute inset-0 bg-background/40 backdrop-blur-[2px]" />

              <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
                <span className="text-sm sm:text-base font-medium text-primary mb-4 tracking-widest uppercase font-sans">
                  {slide.intro}
                </span>
                <h1 className="text-4xl sm:text-5xl md:text-7xl font-light text-foreground mb-6 leading-tight font-serif tracking-widest">
                  {slide.title}
                </h1>
                <p className="text-lg sm:text-xl text-muted-foreground mb-8 max-w-2xl font-sans">
                  {slide.description}
                </p>
                <Button asChild size="lg" className="px-8 py-6 text-base font-bold rounded-sm bg-gradient-to-br from-primary to-[#8e7b54] text-primary-foreground hover:opacity-90 shadow-md">
                  <Link to={slide.ctaLink}>{slide.ctaText}</Link>
                </Button>
              </div>
            </CarouselItem>)}
        </CarouselContent>
        
        
      </Carousel>
    </section>;
}